module.exports = __webpack_public_path__ + "img/w37.e9799ae9.svg";